import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './features/home/Home';
import ChatRoom from './features/chat/ChatRoom';
import JoinChat from './features/join/JoinChat';

export default function App() {
  return (
    <Router>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/create-room" element={<JoinChat />} />
        <Route path="/room/:roomId" element={<ChatRoom />} />
      </Routes>

    </Router>
  );
}
